import React from 'react';
import {
  titleUI,
  textUI,
  textSchema,
  firstNameLastNameNoSuffixSchema,
  firstNameLastNameNoSuffixUI,
} from 'platform/forms-system/src/js/web-component-patterns';

import { validateWhiteSpace } from 'platform/forms/validations';

export default {
  uiSchema: {
    ...titleUI({
      title: 'Governing Body, Officials and Faculty information',
      description: (
        <span className="vads-u-display--block vads-u-margin-top--4">
          Enter the information of a school governing body personnel, school
          official, or faculty member.
        </span>
      ),
    }),
    fullName: firstNameLastNameNoSuffixUI(),
    title: {
      ...textUI({
        title: 'Title',
        validations: [validateWhiteSpace],
        errorMessages: {
          required: 'Enter a title',
        },
      }),
    },
  },

  schema: {
    type: 'object',
    properties: {
      fullName: firstNameLastNameNoSuffixSchema,
      title: { ...textSchema, maxLength: 200 },
    },
    required: ['fullName', 'title'],
  },
};
